import React from 'react'

function Footer() {
    return (
        <div id="footer">
        <span>Product by @Codified Coder</span>
       </div>
    )
}

export default Footer
